import { useState } from "react";

import { useParams } from "react-router-dom";

import { useSession } from "hooks/useSession";
export function useSessionHeader() {
  const { cancelSessionMutation } = useSession();

  const [open, setOpen] = useState(false);
  const { id } = useParams<{ id: string }>();

  const handleCancelSession = () => {
    setOpen(true);
  };

  return { cancelSessionMutation, open, setOpen, id, handleCancelSession };
}
